/*
 * @Author: huangzq
 * @Date: 2020-01-02 15:56:06
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-01-06 14:56:47
 * @Desc: 预览设置标题
*/
<template>
  <div class="set-title">
    <ul class="set-list">
      <li
        v-for="item in setList"
        :key="item.type"
        :class="{'is-active':setType===item.type}"
        @click="$emit('update:setType',item.type)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SetTitle',
  props: {
    setType: {
      type: String,
      default: ''
    },
    setList: {
      type: Array,
      default () {
        return []
      }
    }
  }

}
</script>

<style lang='scss' scoped>
.set-title {
  .set-list {
    display: flex;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 40px;
      font-size: 14px;
      color: #262626;
      background-color: #e8e8e8;

      @extend .cursor;
    }

    .is-active {
      color: #fefefe;
      background-color: #009cff;
    }
  }
}
</style>
